const o = {
  test: (t) => t === "auto",
  parse: (t) => t
};
export {
  o as auto
};
